"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningThunderstorm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const WarningThunderstorm = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "warning-thunderstorm", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "warning-thunderstorm", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M22.278 14.003h-3.503l2.452-3.266.03-.03L25.78 4H14.893L7.158 17.474c-.292.496-.175 1.137.32 1.516.205.146.468.234.701.234h4.029l-.847 7.612c-.03.379.088.787.38 1.05.233.204.525.291.788.291.35 0 .671-.146.905-.437l9.807-11.783c.35-.437.38-1.05 0-1.516-.233-.321-.613-.438-.963-.438z", fill: "#262626" }) })) })));
};
exports.WarningThunderstorm = WarningThunderstorm;
